"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@gibme/web-ui");
const crypto_browser_1 = __importDefault(require("@gibme/crypto-browser"));
const clear_link = () => {
    $('#footer').empty().addClass('d-none');
};
const make_link = (obj) => {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(obj)) {
        params.set(key, value);
    }
    params.set('verify', '');
    const link = `https://cyphr.me/ed25519_tool/ed.html#?${params.toString()}`;
    console.log(link);
    $('#footer').removeClass('d-none')
        .empty()
        .append($(`<a href="${link}" target="_blank">Verify on Cyphr.me</a>`));
};
const update_entropy = (entropy) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!window.cryptomodule)
        return;
    $('#entropy').val(entropy.entropy);
    $('#mnemonic').val(entropy.mnemonic_phrase);
    const seed = yield window.cryptomodule.generate_seed(entropy.entropy);
    $('#seed').val(seed);
    $('#path').val(window.cryptomodule.make_path(44, 901, 0, 0, 0));
    const keys = yield window.cryptomodule.generate_child_key(seed, 44, 901, 0, 0, 0);
    $('#private_key').val((_a = keys.private_key) !== null && _a !== void 0 ? _a : '');
    $('#secret_key').val(keys.secret_key);
    $('#public_key').val(keys.public_key);
    yield sign();
});
const sign = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!window.cryptomodule)
        return;
    clear_link();
    const message_element = $('#message').removeClass('is-invalid');
    const signature_element = $('#signature');
    const signature_status = $('#signature_status').empty()
        .append($.createAwesomeIcon('question').addClass('text-primary'));
    const message = message_element.val().trim();
    if (!message) {
        message_element.addClass('is-invalid');
        return;
    }
    const secret_key = $('#secret_key').val().trim();
    try {
        const signature = yield window.cryptomodule.generate_rfc8032_signature(message, secret_key);
        signature_element.val(signature);
        signature_status.empty()
            .append($.createAwesomeIcon('check')).addClass('text-success');
        make_link({
            alg_type: 'Msg',
            msg_enc: 'Text',
            msg: encodeURIComponent(message),
            key_enc: 'Hex',
            key: yield window.cryptomodule.secret_key_to_public_key(secret_key),
            sig: signature
        });
    }
    catch (_a) {
        signature_element.val('');
    }
});
const verify = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!window.cryptomodule)
        return;
    clear_link();
    const message_element = $('#message').removeClass('is-invalid');
    const signature_element = $('#signature');
    const signature_status = $('#signature_status').empty()
        .append($.createAwesomeIcon('question'));
    const message = message_element.val().trim();
    if (!message) {
        message_element.addClass('is-invalid');
        return;
    }
    const public_key = $('#public_key').val().trim();
    const signature = signature_element.val().trim();
    try {
        const check = yield window.cryptomodule.check_rfc8032_signature(message, public_key, signature);
        if (check) {
            signature_status.empty()
                .append($.createAwesomeIcon('check').addClass('text-success'));
            make_link({
                alg_type: 'Msg',
                msg_enc: 'Text',
                msg: encodeURIComponent(message),
                key_enc: 'Hex',
                key: public_key,
                sig: signature
            });
        }
        else {
            signature_status.empty()
                .append($.createAwesomeIcon('xmark').addClass('text-danger'));
        }
    }
    catch (_a) {
        signature_status.empty()
            .append($.createAwesomeIcon('xmark').addClass('text-danger'));
    }
});
$(() => __awaiter(void 0, void 0, void 0, function* () {
    const crypto = window.cryptomodule = yield crypto_browser_1.default.init();
    $('#load').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
        const mnemonic = $('#mnemonic');
        const words = mnemonic.removeClass('is-invalid').val();
        if (words.length === 0)
            return;
        try {
            const entropy = yield crypto.entropy_recover(words);
            yield update_entropy(entropy);
        }
        catch (_a) {
            mnemonic.addClass('is-invalid');
        }
    }));
    $('#random128').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
        const entropy = yield crypto.random_entropy(undefined, 128, false);
        yield update_entropy(entropy);
    })).trigger('click');
    $('#random256').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
        const entropy = yield crypto.random_entropy(undefined, 256, false);
        yield update_entropy(entropy);
    }));
    $('#sign').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
        yield sign();
    }));
    $('#verify').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
        yield verify();
    }));
}));
